import { useState } from "react";
import { useGroups } from "../../../../../Settings/General/OrganisationLevelGroups/context";
import { useCustomFields } from "../../../../../Settings/CustomFields/context";

export const useInitialState = () => {
    const { groups } = useGroups();
    const { timesheetCustomFields } = useCustomFields();
    const [initialState] = useState({
        hiddenColumns: [
            "status",
            "job",
            "location",
            "scheduled-amount",
            "payCode.description",
            ...groups.reduce((total, { allocatedBy, level }) => {
                if (!allocatedBy) {
                    return total.concat(level.replace("_", ""));
                }
                return total;
            }, []),
            ...timesheetCustomFields
                .filter(({ showByDefault }) => !showByDefault)
                .map(({ code }) => `customFields.${code}`),
        ],
    });
    return initialState;
};